import { get, map } from 'lodash'

import { processFilesToUpload } from 'utils/formatters/file'
import { API } from 'utils/helpers/api/api'

export const uploadFiles = (files, uuid) => {
  const { fileNames, fileMap } = processFilesToUpload(files)
  const url = `/public/forms/upload-urls?uuid=${uuid}`
  const requestData = {
    fileNames,
  }
  const options = {
    headers: { 'Content-Type': 'application/octet-stream' },
    suppressAuth: true,
  }

  return API.post(url, requestData).then(response => {
    const responseData = get(response, 'data')
    const saveAllPromises = map(responseData, details =>
      API.put(get(details, 'url'), fileMap[get(details, 'fileName')], options),
    )
    const resultFiles = map(responseData, details => ({
      name: get(details, 'fileName'),
      objectStoreKey: get(details, 'objectKey'),
      fileUrl: get(details, 'url'),
    }))

    return Promise.all(saveAllPromises).then(() => resultFiles)
  })
}
